import {
  FinanceMessageDocument,
  FinanceMessageQuery,
  MarkFinanceMessageAsReadDocument,
  MarkFinanceMessageAsReadMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'

export type Message = FinanceMessageQuery['finance']['message']

export const useMessage = (id: string) => {
  const { loading, data, error } = useQuery(FinanceMessageDocument, {
    variables: {
      id,
    },
  })

  const [markMessageAsRead] = useMutation(MarkFinanceMessageAsReadDocument, {
    extractorFn: (data: MarkFinanceMessageAsReadMutation) =>
      data.financeMutations.markAsReadFinanceMessage,
  })

  return {
    loading,
    error,
    message: data?.finance.message,
    markMessageAsRead,
  }
}
